import { combineReducers } from 'redux';
import { firestoreReducer } from 'redux-firestore' // made for sync our firestore data with our state in the backend
import { firebaseReducer } from 'react-redux-firebase'
import adminReducer from './adminReducer'
import siteReducer from './siteReducer'
import authReducer from './authReducer'

const rootReducer = combineReducers({
  site: siteReducer,
  admin: adminReducer,
  auth: authReducer,
  firestore: firestoreReducer,
  firebase: firebaseReducer
})

export default rootReducer